import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['count', 'submit']

  updateCount() {
    const checked = this.element.querySelectorAll('input[name="example_ids[]"]:checked').length
    this.countTarget.textContent = checked
    this.submitTarget.disabled = checked === 0
  }
}
